import styled from 'styled-components'

const ListItemMenuStyle = styled.div`
  .moreButton {
    height: 24px;
    min-width: 24px;
    padding: 0;
  }
`

export default ListItemMenuStyle
